<template>
  <!-- Dialogo para indicar errores -->
  <v-dialog
    v-model="parametros.dialogError"
    max-width="440"
  >
    <v-card>
    	<v-card-text>
  			<v-card class="elevation-0 text-center pt-4">
  				<v-icon v-if="esError" color="error" large class="mb-3">mdi-alert-circle-outline</v-icon>
  				<span class="text-headline" style="white-space: pre-line">
  				 	{{ parametros.mensaje }}
  				</span>
  			</v-card>
    	</v-card-text>
    	<v-card-actions class="flex-column pa-4 pt-0">
        <v-btn
          v-if="esError"
          color="warning"
          depressed
          block
          large
          class="text-capitalize mb-2"
          @click="reportarProblema"
        >
          <v-icon left small>mdi-bug-outline</v-icon>
          Reportar problema
        </v-btn>
		    <v-btn 
          :color="parametros.color" 
          dark 
          block 
          @click="cerrar" 
          class="text-capitalize elevation-8"
          large
          > 
            Ok!
          </v-btn>
    	</v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { BUG_REPORT_EVENT_NAME, buildManualBugContext } from '@/utils/bugReporter'

export default {
  props: [
    'parametros',
  ],

  computed: {
    esError() {
      return this.parametros && this.parametros.color !== 'success'
    },
  },

  methods: {
    cerrar() {
      this.parametros.dialogError = false
    },

    reportarProblema() {
      const mensaje = this.parametros && this.parametros.mensaje
        ? String(this.parametros.mensaje).trim()
        : ''

      this.parametros.dialogError = false

      const context = buildManualBugContext({
        store: this.$store,
        router: this.$router,
      })
      context.source = 'alerta'
      context.error = { message: mensaje || 'Error reportado desde alerta' }

      window.dispatchEvent(new CustomEvent(BUG_REPORT_EVENT_NAME, { detail: context }))
    },
  },
}
</script>
